// Records whose date range overlaps the client's report period (all records if no period set).
export const pmaxInPeriod = (records = [], start, end) =>
  records.filter((r) => !start || !end || (r.report_start <= end && r.report_end >= start));

const clicksPct = (rec) => {
  const row = (rec.event_types || []).find((t) => /click/i.test(t.type || ""));
  return row ? Number(row.pct) || 0 : null;
};

// Clicks: exact count from the Campaign Summary when attached, else events x the "Clicks" share.
export const pmaxClicks = (rec) => {
  if (rec.summary?.clicks) return rec.summary.clicks;
  const pct = clicksPct(rec);
  return pct == null ? rec.events || 0 : Math.round((rec.events || 0) * (pct / 100));
};

// Impressions: whichever report was uploaded most recently wins (no double counting).
export const pmaxImpressions = (rec) => {
  const s = rec.summary;
  if (s?.impressions && (s.uploaded_at || "") > (rec.created_at || "")) return s.impressions;
  return rec.impressions || 0;
};

// PMAX CTR benchmarks (PPC.io 2026: median 1.29%, middle 50% of accounts 0.83% to 2.30%).
export const ctrTier = (ctr) => {
  if (ctr >= 2.3) return "Click rate in the top tier of Performance Max accounts";
  if (ctr >= 1.29) return "Click rate above the typical Performance Max account";
  return null;
};

export const pmaxTotals = (records = []) => ({
  impressions: records.reduce((s, r) => s + pmaxImpressions(r), 0),
  clicks: records.reduce((s, r) => s + pmaxClicks(r), 0),
});

const TYPE_LABELS = {
  YOUTUBE_VIDEO: "YouTube Video",
  BUSINESS_NAME: "Business Name",
  TEXT: "Text",
  IMAGE: "Image",
  SITELINK: "Sitelink",
  CALLOUT: "Callout",
  LOGO: "Logo",
};

export const prettyType = (t = "") => {
  const key = t.trim().toUpperCase().replace(/\s+/g, "_");
  if (TYPE_LABELS[key]) return TYPE_LABELS[key];
  if (/trueview|video/i.test(t)) return "Video Views";
  return t.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

export const fmtNum = (n) => Number(n || 0).toLocaleString();

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtPeriod = (start, end) => {
  if (!start || !end) return "";
  const [sy, sm] = start.split("-");
  const [ey, em] = end.split("-");
  if (sy === ey && sm === em) return `${MONTHS[+sm - 1]} ${sy}`;
  return `${MONTHS[+sm - 1]} ${sy} to ${MONTHS[+em - 1]} ${ey}`;
};

export const computeDelta = (current, prior) => {
  if (current == null || prior == null || prior === 0) return null;
  const pct = ((current - prior) / prior) * 100;
  if (Math.abs(pct) < 0.5) return { pct: 0, direction: "flat" };
  return { pct, direction: pct > 0 ? "up" : "down" };
};
